let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jA0Tl")).then(() => parcelRequire('6grIN'));